<template>
    <a :href="$root.baseUrl + '/real-estate'" class="cards-main__link blue-btn">
        {{ finalText | trans }}
    </a>
</template>

<script>
export default {
    name: "GoToPropertiesButton",
    props: {
        text: {
            type: String,
            default: ''
        }
    },
    computed: {
        finalText() {
            // for case when this.text is empty string
            return this.text || 'View more';
        }
    }
}
</script>
